import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var BackArrowIcon = function BackArrowIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.72 3.97a.75.75 0 0 1 1.06 1.06l-6.22 6.22h14.69a.75.75 0 0 1 .743.648L21 12a.75.75 0 0 1-.75.75H5.56l6.22 6.22a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0l-7.5-7.5-.064-.072A.752.752 0 0 1 3 12l.004.077a.754.754 0 0 1-.004-.06V12a.765.765 0 0 1 .129-.42.748.748 0 0 1 .09-.11l-.068.078a.754.754 0 0 1 .069-.078z"
  }));
};

BackArrowIcon.displayName = 'BackArrowIcon';
export default BackArrowIcon;